import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingPartRightStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm-1-2.1a5.002 5.002 0 0 1 0-9.8v9.8ZM9 9v3.9A5.006 5.006 0 0 0 12.9 9H9Zm3.9-2A5.006 5.006 0 0 0 9 3.1V7h3.9Z"
    />
  </svg>
);
export default IconDrillingPartRightStrokedSizeS;
